import React from 'react';
import './BusinessModel.less';
import { RadioButton, RadioGroup } from '@homeaway/react-form-components';
import { ButtonPrimary } from '@homeaway/react-buttons';
import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import { MERCHANT_OF_RECORD } from '../../utils/constants';
import AlertBox from '../Alert/Alert';

class BusinessModel extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getBusinessModelChoices(translations, handleChoiceChange, businessModelChoice) {
        return (
            <div>
                <RadioGroup name="BusinessModelChoice" ariaLabel="Business model choices for agency, or vrbo as merchant of record">
                    <RadioButton
                        className="business-model-toggle-button"
                        id="agencyChoice"
                        label={translations['ipmob.business_model.agency_model']}
                        value={MERCHANT_OF_RECORD.AGENCY}
                        onChange={handleChoiceChange}
                        size="sm"
                        checked={businessModelChoice === MERCHANT_OF_RECORD.AGENCY}
                        type={'radio'}
                    />
                    <span className="business-model-choice-description">{translations['ipmob.business_model.agency_model_text_1']}</span>
                    <RadioButton
                        className="business-model-toggle-button"
                        id="expediaMORChoice"
                        label={translations['ipmob.business_model.vrbo_mor']}
                        value={MERCHANT_OF_RECORD.EXPEDIA}
                        onChange={handleChoiceChange}
                        size="sm"
                        checked={businessModelChoice === MERCHANT_OF_RECORD.EXPEDIA}
                        type={'radio'}
                    />
                    <span className="business-model-choice-description">{translations['ipmob.business_model.vrbo_mor_text_1']}</span>
                </RadioGroup>
            </div>
        );
    }

    render() {
        const {
            translations,
            handleBackButtonClick,
            businessModelChoice,
            handleChoiceChange,
            enableBusinessModelContinueBtn,
            handleNextButtonClick,
            serviceError,
            handleAlertDismiss
        } = this.props;

        return (
            <div id="businessModelPage" className="business-model-page">
                {
                    (serviceError)
                        ? <div className="alert-panel">
                            <AlertBox
                                messageKey={serviceError}
                                translations={translations}
                                handleAlertDismiss={handleAlertDismiss}
                                size={'sm'}
                            />
                        </div>
                        : null
                }
                <div className="business-model-page-wrapper">
                    <div className="business-model-heading">
                        <h1>{translations['ipmob.business_model.heading']}</h1>
                    </div>
                    <div className="business-model-description">
                        <span>{translations['ipmob.business_model.description_1']}</span>
                    </div>
                    <div className="business-model-description">
                        <span>{translations['ipmob.business_model.description_2']}</span>
                    </div>
                    <div className="business-model-toggle-button-wrapper">
                        {
                            this.getBusinessModelChoices(translations, handleChoiceChange, businessModelChoice)
                        }
                    </div>
                </div>
                <div className="business-model-page-buttons">
                    <ButtonPrimary
                        className="business-model-page-back"
                        label={translations['ipmob.button.text_1']}
                        type="submit"
                        value="Submit"
                        id={'Back'}
                        onClick={event => handleBackButtonClick(event)}
                    />
                    <ButtonPrimary
                        className="business-model-page-next"
                        label={translations['ipmob.button.text_2']}
                        type="submit"
                        value="Submit"
                        id={'Continue'}
                        onClick={event => handleNextButtonClick(event)}
                        disabled={!enableBusinessModelContinueBtn}
                    />
                </div>
                <img className="business-model-page-img" src={backgroundImage()}/>
            </div>
        );
    }
}

export default BusinessModel;